import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { LazyLoad } from '../../../LazyLoad/LazyLoad'

import './MenuItemImage.css'

export const MenuItemImage = ({ imageUrl, outOfStock }) => {
  if (!imageUrl) return <div styleName='spacer' />

  return <LazyLoad rootMargin={'0px 0px 100% 0px'}>
    {loaded => (<div
      data-testid='menu-item-image'
      style={{backgroundImage: loaded && `url(${imageUrl})`}}
      styleName={cx('image', { outOfStock })}
    />)}
  </LazyLoad>
}

MenuItemImage.propTypes = {
  imageUrl: PropTypes.string,
  outOfStock: PropTypes.bool
}
